import * as trackingEvents from "@goodgamestudios/tracking-event-types";

// TODO @HTML5  HTML-2929 HTML-2818  we should only use events that have valid types / validationmappings coming from the https://source.services.ggs-net.com/Foundation-HTML5/tracking-event-mappings/ repo

export class TrackingEventIds {
    public static CONNECTION: number = trackingEvents.Connection.ID;
    public static IMPRESSION: number = trackingEvents.Impression.ID;
    public static CLIENT_LOAD: number = trackingEvents.ClientLoad.ID;
    public static AB_TEST_TIMEOUT_TRACKING: number =  39;
    public static SHOP_BACK_BUTTON: number =  40;
    public static WORLD_ASSIGNMENT: number = trackingEvents.WorldAssignment.ID;
    public static PROFILING: number =  trackingEvents.Profiling.ID;
    public static SHOP_LOADED: number = 66;
    public static GAME_PAYMENT_SHOP_CLICK: number =  trackingEvents.GamePaymentshopClick.ID;
    public static PSP_LOADED: number = 74;
    public static SHOP_CHECKOUT: number = 79;
    public static DESKTOP_DEVICE_INFORMATION: number = 86;
    public static ASSETS_LOADING_SPEED: number = 92;
    public static LP_JOURNEY: number = 93;
    public static IN_GAME_PERFORMANCE: number =  trackingEvents.InGamePerformance.ID;
    public static INVITATION: number =  trackingEvents.Invitation.ID;
    public static FACEBOOK_CONNECTION: number =  trackingEvents.FacebookConnection.ID;
    public static FACEBOOK_USER_DATA: number = 99;
    public static CLIENT_FUNNEL: number = trackingEvents.ClientFunnel.ID;
}
